import { useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_SCOPE } from '../constants/constants';
import { BrandContext } from '../contextProviders/brandContext';

const useStepupChallenge = () => {
  const { loginWithRedirect } = useAuth0();

  const {
    activeBrandContext: {
      cspConfiguration: {
        auth0Config: {
          [process.env.REACT_APP_ENV]: { cspMfaUrl }
        }
      }
    }
  } = useContext(BrandContext);

  const stepUpSmsChallenge = async (redirectUri, isPriviledged) => {
    const auth0AuthorizationParams = {
      audience: cspMfaUrl,
      scope: AUTH0_SCOPE,
      privileged: isPriviledged
    };

    try {
      // Step up SMS MFA
      await loginWithRedirect({
        authorizationParams: {
          ...auth0AuthorizationParams,
          redirect_uri: redirectUri
        }
      });
    } catch (error) {
      throw new Error('Error SMS challenge: ', error);
    }
  };
  return { stepUpSmsChallenge };
};

export default useStepupChallenge;
